import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Form from '../components/Form.vue'

Vue.use(VueRouter)

const routes = [
	// 首页路由
	{
		path: '/',
		name: 'home',
		component: Home,
		meta:{
			requierAuth:false
		}
	},
	//登录页
	{
		path:'/login',
		name:'login',
		meta:{
			title:'login',
			show:true,
			requierAuth:false
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component:Login
	},
	//密码重置
	{
		path:'/pwreset',
		name:'pswreset',
		meta:{
			title:'pswreset',
			requierAuth:false
		},
		component: () => import(/* webpackChunkName: "pswreset" */ '../views/PswReset.vue'),
	},
	//注册
	{
		path:'/register',
		name:'register',
		component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
		meta:{
			title:'register',
			requierAuth:false
		},
	},
	//剧本列表页
	{
		path:'/morescriptlist',
		name:'scriptlist',
		component: () => import(/* webpackChunkName: "scriptlist" */ '../views/ScriptList.vue'),
		meta:{
			title:'scriptlist',
			requierAuth:false
		}
	},
	//成功案例详情
	{
		path:'/successdetail',
		name:'success',
		component: () => import(/* webpackChunkName: "success" */ '../views/SuccessCase.vue'),
		meta:{
			title:'success',
			requierAuth:false
		}
	},
	//剧本详情页
	{
		path:'/scriptdetail',
		name:'scriptdetail',
		component: () => import(/* webpackChunkName: "scriptdetail" */ '../views/ScriptDetail.vue'),
		meta:{
			title:'scriptdetail',
			requierAuth:false
		}
	},
	//剧本目录页
	{
		path:'/scriptmenu/:id/:type',
		name:'scriptmenu',
		meta:{
		title:'scriptmenu',
		requierAuth:false
		},
		component:() => import(/* webpackChunkName: "scriptmenu" */ '../components/ScriptMenu.vue'),
	},
	//申请指定章节表单
	{
		path:'/askformore/:id',
		name:'askformore',
		meta:{
			title:'askformore',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName: "askformore" */ '../views/AskForMore.vue'),
	},
	//查看全部评论页/添加评论页
	{
		path:'/allcomment',
		name:'allcomment',
		meta:{
			title:'allcomment',
			requierAuth:false
		},
		component:() => import(/* webpackChunkName: "allcomment" */ '../views/AllCommentPage.vue'),
	},
	//二级评论列表页
	{
		path:'/seccomment',
		name:'seccomment',
		meta:{
			title:'seccomment',
			requierAuth:false
		},
		component:() => import(/* webpackChunkName: "seccomment" */ '../views/SecondComment.vue'),
	},
	//剧本洽谈页
	{
		path:'/talkover/:id',
		name:'talkover',
		meta:{
			title:'talkover',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName: "talkover" */ '../views/TalkOver.vue'),
	},
	//兑换码页
	{
		path:'/exchangecode/:id',
		name:'exchangecode',
		meta:{
			title:'exchangecode',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName: "invitecode" */ '../views/ExchangeCode.vue'),
	},
	//剧本内容页
	{
		path:'/scriptread',
		name:'contentpage',
		meta:{
		title:'contentpage',
		requierAuth:true
		},
		component:() => import(/* webpackChunkName: "contentpage" */ '../views/ContentPage.vue'),
	},
	//个人中心首页
	{
		path:'/usercenter',
		name:'usercenter',
		meta:{
			title:'usercenter',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"usercenter" */ '../views/UserCenter.vue')
	},
	//实名认证页
	{
		path:'/authen',
		name:'authen',
		meta:{
			title:'authen',
			show:false,
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"authen" */ '../views/AuthenPage.vue')
	},
	//消息中心
	{
		path:'/msgcenter',
		name:'msgcenter',
		meta:{
			title:'msgcenter',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"msgcenter" */ '../views/MsgCenter.vue')
	},
	//消息详情页
	{
		path:'/msgdetail',
		name:'msgdetail',
		meta:{
			title:'msgdetail',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"msgdetail" */ '../views/MsgDetail.vue')
	},
	//我的关注页
	{
		path:'/followlist',
		name:'followlist',
		meta:{
			title:'followlist',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"followlist" */ '../views/FollowList.vue')
	},
	//我的投稿我的草稿页
	{
		path:'/myscriptlist',
		name:'myscriptlist',
		meta:{
			title:'myscriptlist',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"myscriptlist" */ '../views/MyScriptList.vue')
	},
	//个人资料页
	{
		path:'/userinfo',
		name:'userinfo',
		meta:{
			title:'userinfo',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"userinfo" */ '../views/UserInfo.vue')
	},
	//编辑个人资料页
	{
		path:'/edituserinfo',
		name:'edituserinfo',
		meta:{
			title:'edituserinfo',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"edituserinfo" */ '../views/EditUserInfo.vue')
	},
	//编辑个人资料修改笔名
	{
		path:'/penname/:name',
		name:'penname',
		meta:{
			title:'penname',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"penname" */ '../views/PenName.vue')
	},
	//编辑个人资料修改邮箱
	{
		path:'/email/:email',
		name:'email',
		meta:{
			title:'email',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"penname" */ '../views/Email.vue')
	},
	//编辑个人资料自我介绍
	{
		path:'/selfintro',
		name:'selfintro',
		meta:{
			title:'selfintro',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"selfintro" */ '../views/SelfIntro.vue')
	},
	//编辑个人资料代表作品
	{
		path:'/works',
		name:'works',
		meta:{
			title:'works',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"works" */ '../views/Works.vue')
	},
	//编辑个人资料擅长题材
	{
		path:'/goodat',
		name:'goodat',
		meta:{
			title:'goodat',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"goodat" */ '../views/GoodAt.vue')
	},
	//编辑个人资料获奖经历
	{
		path:'/prize',
		name:'prize',
		meta:{
			title:'prize',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"prize" */ '../views/Prize.vue')
	},
	//关于我们
	{
		path:'/companyprofile',
		name:'aboutus',
		meta:{
			title:'aboutus',
			requierAuth:false
		},
		component:() => import(/* webpackChunkName:"aboutus" */ '../views/AboutUs.vue')
	},
	//意见反馈
	{
		path:'/advicefeedback',
		name:'feedback',
		meta:{
			title:'feedback',
			requierAuth:false
		},
		component:() => import(/* webpackChunkName:"feedback" */ '../views/FeedBack.vue')
	},
	//邀请码
	{
		path:'/invitecode',
		name:'invitecode',
		meta:{
			title:'invitecode',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName: "invitecode" */ '../views/InviteCode.vue'),
	},
	//安全中心
	{
		path:'/safecenter',
		name:'security',
		meta:{
			title:'security',
			requierAuth:true
		},
		component:() => import(/* webpackChunkName:"security" */ '../views/SecurityCenter.vue')
	},
	//帮助中心
	{
		path:'/helpcenter',
		name:'help',
		meta:{
			title:'help',
			requierAuth:false
		},
		component:() => import(/* webpackChunkName:"help" */ '../views/HelpCenter.vue')
	},
	//帮助中心详情
	{
		path:'/helpdetail',
		name:'helpdetail',
		meta:{
			title:'helpdetail',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/HelpDetail.vue')
	},
	//隐私政策
	{
		path:'/legalstatement',
		name:'policy',
		meta:{
			title:'policy',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/Policy.vue')
	},
	//剧本上传介绍
	{
		path:'/uploadintro',
		name:'uploadintro',
		meta:{
			title:'uploadintro',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/UploadIntro.vue')
	},
	//评估系统电影详情页
	{
		path:'/filmscoredetail',
		name:'filmscoredetail',
		meta:{
			title:'filmscoredetail',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/FilmScoreDetail.vue')
	},
	//评估系统电影详情页
	{
		path:'/tvscoredetail',
		name:'tvscoredetail',
		meta:{
			title:'tvscoredetail',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/TvScoreDetail.vue')
	},
	//联系我们页
	{
		path:'/contactus',
		name:'contactus',
		meta:{
			title:'contactus',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/ContactUs.vue')
	},
	//爆款列表页
	// {
	// 	path:'/vogue',
	// 	name:'vogue',
	// 	meta:{
	// 		title:'vogue',
	// 		requierAuth:false
	// 	},
	// 	component:()=>import(/* webpackChunkName:"help" */ '../views/Vogue.vue')
	// },
	//爆款详情页
	{
		path:'/voguedetail',
		name:'voguedetail',
		meta:{
			title:'voguedetail',
			requierAuth:false
		},
		component:()=>import(/* webpackChunkName:"help" */ '../views/VogueDetail.vue')
	}
]

const router = new VueRouter({
	linkExactActiveClass:'router-active',
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router